import {makeStyles} from "@material-ui/core/styles";
import {colors} from "../../../shared/colors";

const useStyles = makeStyles( theme => ({
    secondaryGreeting: {
        fontSize: '1.3rem',
    },
    personaIcon: {
        fontSize: '3rem',
        borderRadius: '100px',
        boxShadow: '0px 0px 2px #000',
        padding: '1vh',
        color: 'white',
        backgroundColor: colors.magellanDarkBlue,
        [theme.breakpoints.down(1200)]: {
            display: 'none'
        }
    },
    secondaryGreetingWrapper: {
        paddingLeft: '7vw',
        paddingBottom: '5vh',
    }
}))

export default useStyles